<template>
  <div class="fLetter">
    <div class="fLetter-bg">

      <div class="fLetter-con-bg">
        <div class="fLetter-title">
          预审受理备案函
          <!-- <img src="../../assets/img/bg-title.png" width="338" /> -->
        </div>
        <div class="codeNo">{{detailData.acceptFilingLetterNo}}</div>
        <div class="fLetter-con">
          <h5>[{{detailData.serviceNo}}]{{detailData.submitName}}{{detailData.mainContractName}}</h5>
          <div class="fLetter-con-t">
            <div class="fLetter-con-t-t">
              <div class="fLetter-con-l">
                <p><label class="f-blod">存储方：</label>{{detailData.submitName}}</p>
                <p class="p-flex"><span><label class="f-blod">上链时间：</label>{{ blockchainDate }}</span> <span><label class="f-blod">服务类型：</label>消费投资服务</span></p>
                <p><label class="f-blod">共信社区黑名单比对结果：</label>无异常</p>
                <el-divider></el-divider>
              </div>
              <div class="fLetter-con-r">
                <img src="../../assets/img/code.png" width="65" />
                <p>扫码核验</p>
              </div>
            </div>
            <div class="fLetter-con-t-b">             
              <p><label class="f-blod">区块哈希值：</label></p>
              <p>{{detailData.blockchainHash}}</p>
            </div>
          </div>
          
          <div class="fLetter-con-b">
            <p><label class="f-blod">链证存储主要材料</label></p>
            <p><label class="f-blod">主体身份证明材料</label></p>
            <p><label class="f-blod">仲裁协议</label></p>
            <p><label class="f-blod">已证存储文件</label></p>
            <p><label class="f-blod">已链证存储文件相关证明</label></p>
          </div>
        </div>
      </div>
      
      <div class="fLetter-tag">
        <p>我会认可在国际仲裁云链证存储的证据材料，经我会网络仲发中心初步预中，贵方链证存储的证据材料符合本会互或网仲根规则立案受理条件。</p>
        <p>基于以上链旺存储文件项下产生纠纷和争议事项，本会负责出其裁决书及仲被文书生效证明书并协助贵方裁后的和解，或协助连制执行的相关事宜。</p>
        
        <p style="margin-top: 20px;">《倒审受理备案函》驶编号为{{detailData.filingLetterNo}}的原件为准。</p>
      </div>

      <div class="fLetter-footer">
        <p class="f-blod">{{detailData.disputeResolutionOrgTwo}}</p>
        <p class="f-blod">{{blockchainDate}}</p>
      </div>
    </div>
    <div class="fLetter-but">
      <p class="f-but" @click="downloadPah">预审受理备案函</p>
      <p class="f-but" @click="downloadGzh">预审备案告知函</p>
    </div>
  </div>
</template>

<script>
import baseUrl from '@/api/baseUrl.js'
export default {
  name: "filingLetter",
  data() {
    return {
      id: null,
      detailData: {},
      serviceOptions: [],
      blockchainDate: ''
    }
  },
  created() {
    this.id = this.$route.query.id;
    // this.$api.api.getDicts("gsgg_service_type").then(response => {
    //     this.serviceOptions = response.data;
    // });
    this.getDetial()
  },
  methods: {
    downloadFile(url){
        this.$api.api.downloadFile(url)
    },   
    selectDictLabel(datas, value) {
        var actions = [];
        Object.keys(datas).some((key) => {
            if (datas[key].dictValue == ('' + value)) {
                actions.push(datas[key].dictLabel);
                return true;
            }
        })
        return actions.join('');
    }, 
    // serviceFormat (val) {
    //   return this.selectDictLabel(this.serviceOptions, val);
    // }, 
    downloadPah(){
      this.reportDownload(baseUrl.iaccUrl + '/iacc-contract-platform/contract/consumer/project/contractAcceptLetterReport/'+this.id+'?response-content-type=application/octet-stream', 
      `contractAcceptLetterReport_${new Date().getTime()}.pdf`)
    },
    downloadGzh(){
      this.reportDownload(baseUrl.iaccUrl + '/iacc-contract-platform/contract/consumer/project/contractLetterReport/'+this.id+'?response-content-type=application/octet-stream', 
      `contractLetterReport_${new Date().getTime()}.pdf`)
    },
    //获取详情
    getDetial() {
        this.$api.consumer.proDetail(this.id).then(res => {
            this.listLoading = false;
            if(res.code==200){
                this.detailData = Object.assign({}, res.data); 	
                let dateArr = this.detailData.blockchainDate.split(' ')[0].split('-')
                this.blockchainDate = `${dateArr[0]}年${dateArr[1]}月${dateArr[2]}日`
                // this.detailData.arbitrateProtocolFile = JSON.parse(this.detailData.arbitrateProtocolFile || '[]');

                // this.detailData.planSaveFile = JSON.parse(this.detailData.planSaveFile || '[]');
            }else {
                this.$message.error(res.msg);
            }    
        });      
    },
  }
}
</script>

<style lang="less">
.fLetter{
  font-size: 12px; color:#000;
  .f-blod{font-weight: bold;}
  p{line-height: 20px;}
  &-bg {     
    width: 538px;
    margin: 0 auto; 
    height: 842px;
    background: url("../../assets/img/bg.png") no-repeat;
    background-size: cover;
    overflow: hidden;
    padding: 0px 26px 0 31px;
    position: relative;
  }
  &-con-bg{
    padding-top: 29px; 
    margin-top: 30px; 
  }
  &-title{
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    padding-top: 10px 
  }
  .codeNo{
    position: absolute;
    top: 63px;
    right: 70px;
    font-weight: bold;
  }
  &-con{
    white-space: normal; word-break: break-all;
    h5{text-align: center; font-size: 13px; margin: 18px 0;}
    
    &-t{
      background: rgba(154, 150, 136, 0.2);
      padding: 10px 22px 10px 11px;
      margin: 0 30px;

      &-t{        
        display: flex;
        justify-content: space-between;
      }
      &-b{margin-top: -5px;}
    }
    &-l{
      flex: 1;
      .p-flex{display: flex; justify-content: space-between;}
      .el-divider--horizontal{margin: 12px 0; background-color: #d7d5cf;}
      p{line-height: 18px;}
    }
    &-r{
      margin-left: 15px; margin-top: 5px;
      p{font-weight: normal; text-align: center; margin: 0; font-size: 10px;transform: scale(0.83333); line-height: 10px;}
    }
    &-b{
      padding: 20px 41px;
      p{line-height: 26px;}
      .file-link{cursor: pointer;}
    }
  }
  &-tag{
    color: #A57905; font-weight: normal; padding: 10px 41px; width: 100%;
    p{text-indent: 2em; font-size: 10px; transform: scale(0.83333); transform-origin: 0 0;}
  }
  &-footer{
    text-align: right; padding-right: 40px; margin-top: 30px;
    
  }
  &-but {
    width: 538px; 
    margin: 0px auto 30px;
    .f-but{ color: #00a1ef; text-decoration: underline; cursor: pointer;}
  }
}
</style>